import Lineitem from "./lineitem";
import Upsell from "./upsell";
import Accessory from "./accessory";
import AdditionalCharge from "./additionalCharge";
import Subitem from "./subitem";
import { get as getCookie, set, remove as removeCookie, setCookieForSession } from "../utils/cookies";
import Address from "./address";
import {LineItemType} from "../enums/lineItemType";
import { config } from "../utils/config";
import { ShipmentType } from "../enums/ShipmentType";
import Free from "./freeItem";

export default class Cart {

    id: string;
    customerId: string;
    customerEmail:string;
    anonymousId: string;
    shippingCustomItem: boolean;
    cartDiscountIds: string[];
    appliedGlobalDiscountId: string;
    shippingDiscountIds: string[];
    cartState: string;
    country: string;
    locale: string;
    createdAt: string;
    type: string;
    version: number;
    customerDiscountCoupon: string;
    lineItems: any;
    shippingAddress: Address;
    billingAddress: Address;
    mainItemCount: number;
    disabledItemInfo: any;
    specialInstructionsCartLvl: string;
    taxMode: string;
    taxIdentificationNumber: string;
    fractionDigits: number;
    totalDeliveryCharge: number;
    totalDeliveryChargeWithGlobalDiscount: any;
    totalDeliveryChargeWithCouponDiscount: any;
    totalDeliveryChargeWithAllDiscount: any;
    USBTax: number;
    VAT: number;
    VATPercentage: number;
    customCartSubTotal: number;
    cartSubtotal: number;
    cartSubtotalWithLogoForNA: number;
    cartTotal: number;
    totalDiscountWithoutCurrency: number;
    totalDiscount: number;
    shippingDiscount: number;
    validDiscountCode: string;
    discountExists: boolean;
    totalSavingWithoutShippingDiscount: number;
    cartTotalSaving: number;
    hasPCCItem:boolean;
    apparelItemExists:boolean;
    isCartHazardous: boolean = false;
    shippingType: string;
    emailDomain: string;
    isCartTotalSavingAvailable: boolean;
    isTotalSavingWithoutShippingDiscountAvailable: boolean;
    cartTotalWithShipping: number;
    VATWithoutShipping: number;
    totalVAT: number;
    isShippingDiscountAvailable: boolean;
    cartSubtotalInclVat: number;
    totalDeliveryChargeInclVat: number;
    totalDeliveryChargeExclVat: number;
    discountScope: string;
    isOutOfStockInCart: boolean = false;
    isLineItemsRemoved: Array<any> = [];
    isBelowMOQInCart: boolean = false;
    hasRemovedSizesinCart:boolean = false;
    cartDiscountExist: boolean;
    productDiscountExist: boolean;
    constructor(cart: any = {}) {
        const { shippingCustomItem, shippingDiscountIds } = this.checkShippingCustomItem(cart);
        this.id = cart.id;
        this.customerId = cart.customerId;
        this.customerEmail = cart?.customerEmail || '';
        this.anonymousId = cart.anonymousId;
        this.shippingCustomItem = shippingCustomItem || false;
        this.cartDiscountIds = this.getDiscountIds(cart);
        this.shippingDiscountIds = shippingDiscountIds || [];
        this.appliedGlobalDiscountId = '';
        this.cartState = cart.cartState;
        this.country = cart.country;
        this.locale = cart.locale;
        this.createdAt = cart.createdAt;
        this.type = cart.type;
        this.version = cart.version;
        this.customerDiscountCoupon = cart.custom?.fields?.customerDiscountCoupon;
        this.disabledItemInfo = {
            'containsDisabledItem':false,
            'lineItemIdArray': []
        };
        this.isLineItemsRemoved = this.getIsLineItemsRemoved(cart);
        this.hasRemovedSizesinCart = this.hasRemovedSizesInCart(cart) ?? false;
        this.lineItems = this.parseLineItems({'lineItems': cart.lineItems ?? [], 'customLineItems': cart.customLineItems ?? []});
        this.isOutOfStockInCart = cart?.lineItems?.some((lineItem) => lineItem?.custom?.fields?.isOutOfStock) ?? false;
        this.isBelowMOQInCart = cart?.lineItems?.some((lineItem) => lineItem?.custom?.fields?.isBelowMOQ) ?? false;
        this.hasPCCItem = this.updateCookiePCC(cart?.lineItems?.some((lineItem) => lineItem?.custom?.fields?.postCheckOutCustomization)) ?? false;
        this.apparelItemExists = cart?.lineItems?.some((lineItem) => lineItem?.custom?.fields?.isV2Product) ?? false;
        this.shippingAddress = cart.shippingAddress && new Address(cart.shippingAddress);
        this.billingAddress = cart.billingAddress && new Address(cart.billingAddress);
        this.mainItemCount = Object.keys(this.lineItems).length;
        this.fractionDigits = cart.effectivePrice?.fractionDigits ?? 0;
        this.totalDeliveryCharge = cart.effectivePrice?.basePrice?.shippingItem ?? 0;
        this.USBTax = cart.effectivePrice?.actualPrice?.usbItem ?? 0;
        this.VAT = cart.effectivePrice?.tax?.subtotalwithlogo ?? 0;
        this.VATPercentage = cart.lineItems?.[0]?.effectivePrice?.percentageTaxAmount ?? 0;
        this.cartSubtotal = cart.effectivePrice?.actualPrice?.subtotalwithlogo ?? 0;
        this.totalDeliveryChargeWithAllDiscount = cart.effectivePrice?.actualPrice?.shippingItem ?? null;
        this.customCartSubTotal = cart.custom?.fields?.cartSubTotal ?? 0;
        this.emailDomain = cart.custom?.fields?.emailDomain ?? '';
        this.cartSubtotalWithLogoForNA = cart.effectivePrice?.originalPrice?.subtotalwithlogo ?? 0;
        this.cartTotal = cart.effectivePrice?.actualPriceWithTax?.subtotalwithlogo ?? 0;
        this.taxMode = cart.taxMode ?? 'External';
        this.specialInstructionsCartLvl = cart.custom?.fields?.specialInstructionsForOrder ?? ''
        this.validDiscountCode = cart?.discountCodes?.[0]?.discountCode?.obj?.code || cart?.discountCodes?.[0]?.discountCode?.code || cart.lineItems?.find((lineitem) => lineitem?.custom?.fields?.productDiscountCode)?.custom?.fields?.productDiscountCode || cart.custom?.fields?.customerDiscountCoupon || '';
        this.totalDiscount = cart.effectivePrice?.discount?.total ?? 0;
        this.discountExists = cart?.discountCodes?.some((discount) => discount.state === "MatchesCart") || cart.lineItems?.some((lineItem) => lineItem?.custom?.fields?.productDiscountCode) || false;
        this.cartDiscountExist = cart?.discountCodes?.some((discount) => discount.state === "MatchesCart") || false;
        this.productDiscountExist = cart.lineItems?.some((lineItem) => lineItem?.custom?.fields?.productDiscountCode) || false;
        this.totalDiscountWithoutCurrency = cart.effectivePrice?.cartDiscount
        this.taxIdentificationNumber = cart.custom?.fields?.taxIdentificationNumber ?? ''
        this.cartTotalSaving = cart.effectivePrice?.discount?.total ?? 0;
        this.totalSavingWithoutShippingDiscount = cart.effectivePrice?.discount?.subtotalwithlogo ?? 0;
        this.shippingDiscount = cart.effectivePrice?.discount?.shippingItem ?? 0;
        this.isCartHazardous = Object.keys(this.lineItems).some( key => this.lineItems[key][0].data.isLineItemHazardous)
        this.shippingType = cart?.custom?.fields?.shippingType ?? '';
        this.isCartTotalSavingAvailable = cart?.effectivePrice?.discount?.total !== 0 ? true : false;
        this.isTotalSavingWithoutShippingDiscountAvailable = cart?.effectivePrice?.discount?.subtotalwithlogo !== 0 ? true : false;
        this.cartTotalWithShipping = cart?.effectivePrice?.actualPriceWithTax?.total ?? 0;
        this.VATWithoutShipping = cart?.effectivePrice?.tax?.subtotalwithlogo ?? 0;
        this.totalVAT = cart?.effectivePrice?.tax?.total ?? 0;
        this.isShippingDiscountAvailable = cart?.effectivePrice?.discount?.shippingItem !== 0;
        this.cartSubtotalInclVat = cart?.effectivePrice?.actualPriceWithTax?.subtotalwithlogo ?? 0;
        this.totalDeliveryChargeInclVat = cart?.effectivePrice?.actualPriceWithTax?.shippingItem ?? 0;
        this.totalDeliveryChargeExclVat = cart?.effectivePrice?.actualPrice?.shippingItem ?? 0;
        this.totalDeliveryChargeWithGlobalDiscount = this.calculateTotalDeliveryCharge(cart,"publicDiscount","originalPrice") ?? 0;
        this.totalDeliveryChargeWithCouponDiscount = this.calculateTotalDeliveryCharge(cart,"discount","actualPrice") ?? 0;
        if (
          Object.keys(this.lineItems).some(
            (key) =>
              this.lineItems[key][0]?.data?.productDiscountCode
          )
        ) {
          this.discountScope = "Product";
        } else if (cart?.discountCodes?.[0]?.discountCode?.obj?.code || cart?.discountCodes?.[0]?.discountCode?.code) {
          this.discountScope = "Order";
        } else {
          this.discountScope = "";
        }
        this.checkShippingDiscount();
    }


   public checkShippingDiscount() {
    this.appliedGlobalDiscountId = '';  
  
    if (this.shippingCustomItem && this.shippingDiscountIds.length > 0) {
      const globalCartDiscounts = this.shippingDiscountIds.filter(id => !this.cartDiscountIds.includes(id));
  
      if (globalCartDiscounts.length > 0) {
        this.appliedGlobalDiscountId = globalCartDiscounts[0];  
      }
    }
  }
  
    public parseLineItems({lineItems, customLineItems}){
        const lineItemMap = {};
        const isNaRegion = config('locale') === 'en-US' || config('locale') === 'en-CA' ? true : false;

        const freeItem = lineItems.find((item) => item?.custom?.fields.lineItemType.toLowerCase() === LineItemType.FREE)
        let free_qty = 0;
        if(freeItem){
            free_qty = freeItem.quantity;
        }

        lineItems.filter((item) => {
            item = JSON.parse(JSON.stringify(item));
            const { lineItemType, hasInvalidProductSelection } = item?.custom?.fields;
            if(lineItemType?.toLowerCase() === LineItemType.MAINITEM) {
                item.customLineItems = customLineItems.filter(customItem => customItem.custom.fields.lineItemReference === item.id)
                lineItemMap[item.id] = [
                    {
                        'type': LineItemType[lineItemType?.toUpperCase()],
                        'data': {
                            ...new Lineitem(item),
                            ...(free_qty > 0 ? { free_qty } : {}),
                        },
                    },
                ];
                if(hasInvalidProductSelection){
                    this.setDisabledItemInfo(true,item.id);
                }
            }
        });

        if(freeItem){
            lineItemMap[freeItem?.custom?.fields.lineItemReference].push({ 'type': LineItemType[LineItemType.FREE.toUpperCase()], 
                'data': new Free(freeItem)})
        }

        lineItems.forEach((item) => {
            const { lineItemType, lineItemReference } = item?.custom?.fields;
            if(lineItemType?.toLowerCase() === LineItemType.UPSELL)
            {
                lineItemMap[lineItemReference].push({ 
                    'type': LineItemType[lineItemType.toUpperCase()], 
                    'data': new Upsell(lineItemMap[lineItemReference][0], item)
                })
            }
            else if(isNaRegion && lineItemType?.toLowerCase() === LineItemType.ACCESSORY && item.custom.fields.additionalCharges)
            {
                const additionalChargeInfo = item.custom.fields.additionalCharges ? JSON.parse(item.custom.fields.additionalCharges) : [];
                    additionalChargeInfo.forEach((additionalCharge)=> {
                        lineItemMap[lineItemReference].push({
                            'type': LineItemType.ADDITIONALCHARGE,
                            'data': new AdditionalCharge(lineItemMap[lineItemReference][0], additionalCharge, true, true),
                            'code': additionalCharge.code,
                            'appliedInCart': true
                        })
                    })
            }
            else if(lineItemType?.toLowerCase() === LineItemType.ACCESSORY)
            {
                lineItemMap[lineItemReference].push({
                    'type': LineItemType[lineItemType.toUpperCase()],
                    'data': new Accessory(lineItemMap[lineItemReference][0], item)
                })
            }
            else if(lineItemType?.toLowerCase() === LineItemType.SUBITEM)
            {
                lineItemMap[lineItemReference].push({ 'type': LineItemType[lineItemType.toUpperCase()], 
                'data':new Subitem(lineItemMap[lineItemReference][0], item)})
            }
        })

        //setting up customLineItems
        const mainItemKeys = Object.keys(lineItemMap)
        if(mainItemKeys.length>0){
            mainItemKeys.forEach((lineItemReference) =>{
                const mainItem = lineItemMap[lineItemReference][0];
                const autoAppliedCharges = (isNaRegion && mainItem.data.customLineItems.length> 0 && mainItem.data.customLineItems.filter(customItem => customItem.custom.fields.customLineItemType === LineItemType.ADDITIONALCHARGE)) || [];
                if(autoAppliedCharges.length > 0){
                    const additionalChargeInfo = autoAppliedCharges[0].custom.fields.additionalCharges ? JSON.parse(autoAppliedCharges[0].custom.fields.additionalCharges) : [];
                    additionalChargeInfo.forEach((additionalCharge)=> {
                        lineItemMap[lineItemReference].push({
                            'type': LineItemType.ADDITIONALCHARGE,
                            'data': new AdditionalCharge(lineItemMap[lineItemReference][0], additionalCharge, true),
                            'code': additionalCharge.code,
                            'appliedInCart': true
                        })
                    })
                }
            })
        }

        return lineItemMap;
    }

    //flag for post checkout customization (PCC)
    public updateCookiePCC(PCC){
        if(PCC){
            // If PCC is true, set the cookie
            if(!getCookie('np.pcc')){
                setCookieForSession('np.pcc','true','/');
            }
            return true;
        }else{
            // If PCC is false, remove the cookie
            removeCookie('np.pcc');
            return false;
        }
    }

    public setIdpDate(idpObj){
        let idpProductMap = {};
        idpObj?.dates?.forEach(idpObj =>idpProductMap[idpObj.productId +'_'+idpObj.mcpSku] = idpObj)
        for (const mainItemId of Object.keys(this.lineItems)){
            this.lineItems[mainItemId][0].data.setIdpDate(idpProductMap)
        }
    }

    public setDisabledItemInfo(containsDisabledItem,lineItemId){
        this.disabledItemInfo.containsDisabledItem = containsDisabledItem;
        this.disabledItemInfo.lineItemIdArray.push(lineItemId);
    }

    public checkShippingCustomItem(cart: any): { shippingCustomItem: boolean; shippingDiscountIds: string[] } {
        const shippingDiscountIds: string[] = [];
        const shippingCustomItem = cart?.customLineItems?.some((item: any) => {
            if (item?.custom?.fields?.lineItemType === 'shipping') {
                if (item.discountedPricePerQuantity && item.discountedPricePerQuantity.length > 0) {
                    const discountedPrice = item.discountedPricePerQuantity[0]?.discountedPrice;
                    if (discountedPrice && discountedPrice.includedDiscounts) {
                        discountedPrice.includedDiscounts.forEach((discount: any) => {
                            if (discount.discount && discount.discount.id) {
                                shippingDiscountIds.push(discount.discount.id);
                            }
                        });
                    }
                }
                return true;
            }
            return false;
        }) || false;
        return { shippingCustomItem, shippingDiscountIds };
    }

    public getDiscountIds(cart: any): string[] {
        const discountIds: string[] = [];
        const cartDiscounts = cart?.discountCodes?.[0]?.discountCode?.obj?.cartDiscounts || cart?.discountCodes?.[0]?.discountCode?.cartDiscounts;
        
        if (Array.isArray(cartDiscounts)) {
            cartDiscounts.forEach(item => {
                if (item.id) {
                    discountIds.push(item.id);
                }
            });
        }
        
        return discountIds;
    }

    public calculateTotalDeliveryCharge(cart:any,discountType:string,deliveryChargeType:string){
        if (cart.effectivePrice?.[discountType]?.shippingItem > 0) {
          if (cart.effectivePrice[discountType].shippingItem === this.totalDeliveryCharge) {
            return "Free";
          } else {
            return cart.effectivePrice?.[deliveryChargeType]?.shippingItem ?? 0;
          }
        }
      };

    private getIsLineItemsRemoved(cart){
        if(cart?.isLineItemsRemoved) {
            setCookieForSession('np.isLineItemsRemoved', JSON.stringify(cart?.isLineItemsRemoved), '/');
            return cart.isLineItemsRemoved;
        } else {
            const isLineItemsRemovedArray = getCookie('np.isLineItemsRemoved');
            if(isLineItemsRemovedArray){
                return JSON.parse(isLineItemsRemovedArray);
            } else {
                return [];
            }

        }
    }

    private hasRemovedSizesInCart(cart): boolean {
        const isLineItemsRemovedArray = getCookie("np.isLineItemsRemoved");
        if (!isLineItemsRemovedArray) return false; // Handle case where no cookie exists
    
        const parsedArray = JSON.parse(isLineItemsRemovedArray) || [];
    
        // Create a Set for quick lookup
        const removedItemIds = new Set(parsedArray.map((item) => item.lineItemId));
    
        // Check if any lineItem.id exists in the removedItemIds Set
        return cart?.lineItems?.some((lineItem) => removedItemIds.has(lineItem.id));
    }
}